<!-- 付款单信息 -->
<template>
  <div class="paymentInfo">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="rules"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>

<script>
  // import API from '@/api/financeCenter/payables';
  import PAYMENT_API from '@/api/financeCenter/paymentApply.js';
  import { mapState } from 'vuex';
  // import searchTable from '@/components/form-item/search-table';
  import baseForm from '@/components/form/base-form';
  import { paymentClass } from '@/common/js/paymentMapping.js';
  // import costVue from '../../../../capitalCenter/settle/settlementBatch/components/cost.vue';
  import XEUtils from 'xe-utils';
  export default {
    name: 'paymentInfo',
    components: {
      // searchTable,
      baseForm,
    },
    props: ['invoiceLineAmount', 'canEdit'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      baseDataOptions() {
        return [
          {
            // 公司代码
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.paymentCompanyCode'),
            prop: 'paymentCompanyCode',
            required: true,
            disabled: true,
          },
          {
            // 付款类别
            type: 'select',
            options: paymentClass,
            label: this.$t('paymentListAdd.paymentInfo.paymentType'),
            prop: 'paymentType',
            required: true,
            // disabled: this.baseData.sourceType!='CL'
            disabled: true,
            filterable: true,
          },
          {
            // 付款方式
            type: 'select',
            options: this.paymentMethodList,
            label: this.$t('paymentListAdd.paymentInfo.paymentMethod'),
            prop: 'paymentMethod',
            required: true,
            filterable: true,
            disabled: this.baseData.sourceType == 'PA' ? false : true,
          },
          {
            // 付款日期
            type: 'date',
            label: this.$t('paymentListAdd.paymentInfo.paymentDate'),
            prop: 'paymentDate',
            required: true,
          },
          {
            // 付款银行账户名称
            type: 'searchTable',
            prop: 'bankAccountName',
            searchType: 'bankAccount',
            isMultiple: true,
            label: this.$t('paymentListAdd.paymentInfo.bankAccountName'),
            required: this.baseData.paymentMethod != 'FK04',
            disabled: this.baseData.paymentMethod == 'FK04',
            extraData: {
              bankAccountStatus: '001',
              companyCode: this.baseData.paymentCompanyCode,
              currencyCode: this.baseData.currencyCode == 'CNY' ? 'CNY' : null,
            },
            currentValue: this.baseData.bankAccountName,
          },
          {
            // 付款银行
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.bankName'),
            prop: 'bankName',
            required: this.baseData.paymentMethod != 'FK04',
            disabled: true,
          },
          {
            // 付款银行账号
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.bankAccountNum'),
            prop: 'bankAccountNum',
            required: this.baseData.paymentMethod != 'FK04',
            disabled: true,
          },
          {
            // 收款单位
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.receiveCompanyNo'),
            prop: 'receiveCompanyName',
            required: this.baseData.sourceType != 'CL',
            disabled: true,
          },
          {
            //开户银行
            type: 'select',
            label: this.$t('paymentListAdd.paymentInfo.openingBankNo'),
            options: this.partnersBanks,
            prop: 'receiveBankAccountNum',
            required: this.baseData.sourceType != 'CL',
            filterable: true,
            disabled: false,
          },
          {
            // 银行账号
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.receiveBankAccountNum'),
            prop: 'receiveBankAccountNum',
            required: this.baseData.sourceType != 'CL',
            disabled: true,
          },
          {
            // 联行号
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.bankUnionNumber'),
            prop: 'bankUnionNumber',
            disabled: true,
          },
          {
            // 开户分行
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.bankBranch'),
            prop: 'bankBranch',
            disabled: true,
          },
          {
            // 付款金额
            type: 'amountNumber',
            label: this.$t('paymentListAdd.paymentInfo.paymentAmount'),
            prop: 'paymentAmount',
            required: true,
            disabled: true,
          },
          {
            // 付款金额本位币
            type: 'amountNumber',
            label: this.$t('paymentListAdd.paymentInfo.paymentAccountedAmount'),
            prop: 'paymentAccountedAmount',
            required: true,
            disabled: true,
          },
          {
            // 币种
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.currencyCode'),
            prop: 'currencyName',
            required: true,
            disabled: true,
          },
          {
            // 汇率类型、汇率
            type: 'dict',
            label: this.$t('paymentListAdd.paymentInfo.exchangeType'),
            prop: 'exchangeType',
            dictType: 'exchange_type',
            disabled: false,
            required: true,
            moreInput: true,
            ruleType: 'object',
            validatorKey: this.baseData.exchangeRate,
            moreProp: 'exchangeRate',
            moreType: 'number',
            moreMin: 0,
            moreClearable: true,
            moreRequired: true,
            morePlaceholder: this.$t('paymentListAdd.paymentInfo.auto'),
            // moreDisabled: this.baseData.exchangeType=="Cooperate"
            moreDisabled: false,
          },
          {
            // 汇率日期
            type: 'date',
            label: this.$t('paymentListAdd.paymentInfo.exchangeRateDate'),
            prop: 'exchangeRateDate',
            required: true,
          },
          {
            // 单据状态
            type: 'dict',
            dictType: 'payment_status',
            label: this.$t('paymentListAdd.paymentInfo.requestStatus'),
            prop: 'paymentStatus',
            disabled: true,
          },
          {
            // 单据编号
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.requestNum'),
            prop: 'paymentNum',
            disabled: true,
          },
          {
            // 银行单号
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.bankDocumentNum'),
            prop: 'bankDocumentNum',
            disabled: true,
          },
          {
            // 制单人
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.paymentCreatePersonNo'),
            prop: 'paymentCreatePersonName',
            required: true,
            disabled: true,
          },
          {
            // 制单日期
            type: 'date',
            label: this.$t('paymentListAdd.paymentInfo.paymentCreateDate'),
            prop: 'paymentCreateDate',
            required: true,
            disabled: true,
          },
          {
            // 虚拟标识
            type: 'checkbox',
            text: this.$t('paymentListAdd.paymentInfo.isVirtual'),
            prop: 'isVirtual',
            disabled: true,
          },
          {
            // 银企直连标识
            type: 'checkbox',
            text: this.$t('paymentListAdd.paymentInfo.isDirectConnectionToBank'),
            prop: 'isDirectConnectionToBank',
            disabled: false,
          },
          {
            // 汇款用途
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.paymentUsage'),
            maxlength: 20,
            prop: 'paymentUsage',
            disabled: false,
            required: true,
          },
          {
            // 资金管理系统上报状态
            type: 'dict',
            label: '上报单据状态',
            maxlength: 20,
            dictType: 'fmSendFlag',
            prop: 'fmSendFlag',
            disabled: true,
            required: true,
          },
          {
            // 支付通道
            type: 'dict',
            label: '支付通道',
            maxlength: 20,
            dictType: 'payChannel',
            prop: 'payChannel',
            disabled: false,
            required: true,
          },
          {
            // 落地处理
            type: 'checkbox',
            text: '落地处理',
            prop: 'isManual',
            disabled: false,
          },
          {
            // 摘要 默认待改
            type: 'input',
            label: this.$t('paymentListAdd.paymentInfo.summary'),
            prop: 'summary',
            span: 20,
            maxlength: 30,
            required: true,
          },
        ];
      },
      paymentMethodList() {
        let list = this.baseData.paymentType
          ? paymentClass.find((it) => it.value == this.baseData.paymentType).list
          : [];
        let list1 = XEUtils.clone(list, true);
        if (this.baseData.paymentType == 'PT01') {
          //如果付款方式为货款 付款单可以选择信用证LC 付款申请不可以
          let obj = {
            value: 'FK15',
            label: '信用证L/C',
          };
          list1.push(obj);
        }
        return list1;
      },
      rules() {
        return {};
      },
    },
    watch: {
      invoiceLineAmount() {
        (this.baseData.paymentAmount = this.invoiceLineAmount.paymentAmount),
          (this.baseData.paymentAccountedAmount = this.invoiceLineAmount.paymentAccountedAmount);
      },
    },
    data() {
      return {
        baseData: {
          sourceType: null, // 来源
          id: null,
          version: null, // 版本
          paymentCompanyCode: null, // 公司代码
          paymentCompanyName: null, // 公司
          paymentMethod: null, // 付款方式
          paymentDate: null, // 付款日期
          bankAccountName: null, // 付款银行账户名称
          payBankUnionNumber: null, // (新增回填字段)
          payBankCode: null, // (新增回填字段)
          bankCode: null, // 付款银行
          bankName: null, // 付款银行名称
          bankAccountNum: null, // 付款银行账号
          receiveCompanyNo: null, // 收款单位
          receiveCompanyName: null, // 收款单位名称
          openingBankNo: null, // 开户银行
          openingBankName: null, // 开户银行名称
          receiveBankAccountNum: null, // 银行账号
          bankUnionNumber: null, // 联行号
          bankBranch: null, // 开户分行
          paymentAmount: null, // 付款金额
          paymentAccountedAmount: null, // 付款金额本位币
          currencyCode: null, // 币种
          currencyName: null, // 币种名称
          companyCurrencyCode: null, // 本币币种编码
          companyCurrencyName: null, // 本币币种名称
          exchangeType: null, // 汇率类型
          exchangeRate: null, // 汇率
          exchangeRateDate: null, // 汇率日期
          paymentType: null, // 付款类别
          paymentStatus: null, // 单据状态
          paymentNum: null, // 单据编号
          bankDocumentNum: null, // 银行单号
          paymentCreatePersonNo: null, // 制单人
          paymentCreatePersonName: null, // 制单人名称
          paymentCreateDate: null, // 制单日期
          isVirtual: null, // 虚拟标识
          isManual: null, // 是否落地
          isDirectConnectionToBank: null, // 银企直连标识
          summary: null, // 摘要
          actualPaymentAmount: null, //实际付款金额
          actualPaymentAccountedAmount: null, //实际付款金额本位币
          paymentUsage: null, //汇款用途
          fmSendFlag: 1, //资金上报状态
          payChannel: 2, //支付通道
        },
        partnersBanks: [],
      };
    },
    methods: {
      //基本数据表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'bankAccountName') {
          this.bankAccountChange(value.bankAccountName);
        }
        // 付款方式
        if (prop == 'paymentMethod') {
          if (value.paymentMethod == 'FK15') {
            // 禁止选择信用证L/C
            this.tips('canNotSelLC', 'error');
            value.paymentMethod = null;
          }
          if (value.paymentMethod == 'FK04') {
            this.bankAccountChange();
          }
          this.$emit('paymentMethodChange', value.paymentMethod);
        }
        // 开户银行 --
        if (prop == 'receiveBankAccountNum') {
          this.openingBankChange(value.receiveBankAccountNum);
        }
        // 付款日期变更 汇率日期也跟着变
        if (prop == 'paymentDate') {
          this.baseData.exchangeRateDate = value.paymentDate;
          this.selectTaxRate();
        }
        // 汇率日期和汇率类型
        if (prop == 'exchangeRateDate' || prop == 'exchangeType') {
          this.selectTaxRate();
        }
        // 汇率
        if (prop == 'exchangeRate') {
          this.$emit('calcInvoiceLine', value.exchangeRate);
        }
      },
      // 内部银行账户
      bankAccountChange(val) {
        if (val && val.length > 0) {
          this.baseData.bankAccountName = val[0].bankAccountName;
          this.baseData.bankAccountNum = val[0].bankAccountNum;
          this.baseData.bankName = val[0].branchName;
          this.baseData.isDirectConnectionToBank = val[0].bankConnectionFlag == '1' ? true : false;
          this.baseData.payBankUnionNumber = val[0].bankUnionNumber;
          this.baseData.payBankCode = val[0].bankCode;
        } else {
          this.baseData.bankAccountName = null;
          this.baseData.bankAccountNum = null;
          this.baseData.bankName = null;
          this.baseData.isDirectConnectionToBank = false;
          this.baseData.payBankUnionNumber = null;
          this.baseData.payBankCode = null;
        }
      },
      openingBankChange(val) {
        if (val) {
          let item = this.partnersBanks.find((item) => item.value == val);
          this.baseData.openingBankName = item.bankName;
          this.baseData.openingBankNo = item.bankCode;
          this.baseData.receiveBankAccountNum = item.bankAccount;
          this.baseData.bankUnionNumber = item.associatedLineNumber;
          this.baseData.bankBranch = item.accountBankBranch;
        } else {
          this.baseData.openingBankNo = null;
          this.baseData.openingBankName = null;
          this.baseData.receiveBankAccountNum = null;
          this.baseData.bankUnionNumber = null;
          this.baseData.bankBranch = null;
        }
      },
      async getBankInfo(partnerCode, companyCode) {
        // 获取收款单位对应银行
        let res = await this.$axios.get(PAYMENT_API.GET_PARTER_BANK, { partnerCode, companyCode });
        if (res) {
          if (res.data.code == 0) {
            this.partnersBanks = res.data.data.map((item) => {
              return {
                ...item,
                value: item.bankAccount,
                label: item.bankName + '-' + item.bankAccount,
              };
            });
            if (res.data.data && res.data.data.length == 1) {
              let tempData = res.data.data[0];
              this.baseData.openingBankNo = tempData.bankCode;
              this.baseData.openingBankName = tempData.bankName;
              this.baseData.receiveBankAccountNum = tempData.bankAccount;
              this.baseData.bankUnionNumber = tempData.associatedLineNumber;
              this.baseData.bankBranch = tempData.accountBankBranch;
            }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
      },
      // 汇率值获取
      selectTaxRate() {
        if (this.baseData.companyCurrencyCode == this.baseData.currencyCode) {
          this.baseData.exchangeRate = 1;
          this.$emit('calcInvoiceLine', 1);
        } else {
          this.getRate();
        }
      },
      //获取汇率
      getRate() {
        const params = {
          fromCurrencyCode: this.baseData.currencyCode,
          toCurrencyCode: this.baseData.companyCurrencyCode,
          exchangeDate: this.baseData.exchangeRateDate,
          exchangeType: this.baseData.exchangeType,
        };
        this.$baseRequest.getRate(params).then((res) => {
          if (res) {
            this.baseData.exchangeRate = res.positiveRate;
            this.$emit('calcInvoiceLine', this.baseData.exchangeRate);
          } else {
            this.baseData.exchangeRate = null;
            this.tips('rateInfo', 'error');
          }
        });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`paymentListAdd.message.${info}`),
          type: type,
        });
      },
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        let sign = false;
        let baseData = { ...this.baseData };
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
            Object.keys(baseData).map((item) => {
              if (item.indexOf('is') == 0) {
                return (baseData[item] = baseData[item] ? '1' : '0');
              }
            });
          } else {
            sign = false;
          }
        });
        return sign ? baseData : false;
      },
    },
  };
</script>
